import thunkMiddleware from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import { pushActions } from '../actions/push'

/**
 * Creates the Redux store based on the provided reducer and initialState
 *
 * @param {Function} reducer      - A reducer function as required by createStore from Redux
 * @param {object}   initialState - The initial state to be stored
 * @param {Array}    middleWares  - Additional middlewares to be applied to the Redux store
 *                                  The thunkMiddleware is applied by default.
 * @return {object}  The created Redux store
 */
export function configureStore(reducer, reduxMiddleWares = [], initialState) {
    const middleWares = [thunkMiddleware, ...reduxMiddleWares]
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(...middleWares)))

    // Let the push subsystem listen for schedules added by the module loader
    pushActions.subscribe(store)
    return store
}
